/** Klien API peran terapis. */

import { api } from "./client";

export interface TherapistAppointment {
  id: string;
  bookingCode: string;
  bookingDate: string;
  startTime: string;
  endTime: string;
  status: string;
  notes: string | null;
  patientProfile: { fullName: string; phone: string | null };
  service: { name: string; durationMinutes: number; price: number };
  payment: { status: string } | null;
}

export interface TherapistProfile {
  id: string;
  name: string;
  photoUrl: string | null;
  specialization: string | null;
  bio: string | null;
  services: Array<{ service: { id: string; name: string; price: number; durationMinutes: number } }>;
}

export function fetchAppointments(params: { date?: string; from?: string; to?: string }): Promise<TherapistAppointment[]> {
  const q = new URLSearchParams();
  if (params.date) q.set("date", params.date);
  if (params.from) q.set("from", params.from);
  if (params.to) q.set("to", params.to);
  const query = q.toString();
  return api
    .get<{ appointments: TherapistAppointment[] }>(`/therapist/appointments${query ? `?${query}` : ""}`)
    .then((r) => r.appointments);
}

export function fetchTherapistProfile(): Promise<TherapistProfile> {
  return api.get<{ therapist: TherapistProfile }>("/therapist/me").then((r) => r.therapist);
}

export function therapistAction(id: string, action: "check-in" | "start" | "complete") {
  return api.post<{ booking: { id: string; status: string } }>(
    `/therapist/appointments/${id}/${action}`,
  );
}
